var materea_t=window.materea_t||(window.materea_t=function(k,v){var d=window.materea_texte;if(!d){try{d=JSON.parse(document.getElementById('materea-i18n').textContent)}catch(e){d={}}window.materea_texte=d}var s=d[k];if(s==null)return k;return v?s.replace(/\{(\w+)\}/g,function(m,n){return n in v?v[n]:m}):s});

(function(){
  "use strict";

  var BASIS = window.KATALOG_BASIS || {};
  var PFEIL = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M7 17L17 7M9 7h8v8'/%3E%3C/svg%3E\")";
  document.documentElement.style.setProperty("--pfeil", PFEIL);

  var buchEl = document.getElementById("buch");
  var listeEl = document.getElementById("produkteliste");
  var kopfEl = document.getElementById("produktekopf");
  var zahlEl = document.getElementById("seitenzahl");
  var gesamtEl = document.getElementById("gesamt");
  var registerEl = document.getElementById("register");
  var gitterEl = document.getElementById("gitter");
  var kapitelEl = document.getElementById("kapitel");
  var volltextEl = document.getElementById("volltext");

  var manifest = null, zuordnung = {}, flip = null;
  var STORE_PRODUKT = "/products/";   
  var LADEFENSTER = 4;                

  Promise.all([
    fetch(BASIS.manifest).then(function(r){ return r.json(); }),
    fetch(BASIS.zuordnung).then(function(r){ return r.json(); })
      .catch(function(){ return { zuordnung:{} }; })
  ]).then(function(res){
    manifest = res[0];
    zuordnung = res[1].zuordnung || {};
    bauen();
  }).catch(function(e){
    buchEl.innerHTML = '<p style="color:#6d6a64;padding:60px 0;text-align:center">'
      + materea_t("js.katalog.nicht_geladen");
    console.error("Katalog:", e);
  });

  
  function bauen(){
    var seiten = manifest.seiten;
    gesamtEl.textContent = seiten.length;
    zahlEl.max = seiten.length;

    seiten.forEach(function(s, i){
      var d = document.createElement("div");
      d.className = "seite laedt " + (i % 2 === 0 ? "rechts" : "links");
      d.setAttribute("data-nr", s.nr);
      
      if (i === 0 || i === seiten.length - 1) d.setAttribute("data-density", "hard");

      var img = document.createElement("img");
      img.alt = seitenAlt(s);
      img.setAttribute("data-src", s.bild);
      d.appendChild(img);
      buchEl.appendChild(d);
    });

    volltextEl.innerHTML = seiten.map(function(s){
      return materea_t("js.katalog.h2_katalogseite") + s.nr + (s.kapitel ? ": " + s.kapitel : "") + "</h2>"
           + "<p>" + s.suchtext + "</p>";
    }).join("");

    var s = grenzeSetzen();
    flip = new St.PageFlip(buchEl, {
      width: s, height: s,
      size: "stretch",
      minWidth: 240, maxWidth: 760,
      minHeight: 240, maxHeight: 760,
      showCover: true,
      maxShadowOpacity: 0.42,
      flippingTime: mag() ? 0 : 750,
      usePortrait: true,
      mobileScrollSupport: false,
      clickEventForward: true,     
      useMouseEvents: true,
      drawShadow: true
    });

    flip.loadFromHTML(buchEl.querySelectorAll(".seite"));

    
    
    var wartet = null;
    window.addEventListener("resize", function(){
      clearTimeout(wartet);
      wartet = setTimeout(function(){
        grenzeSetzen();
        try { flip.update(); } catch(e){}
      }, 180);
    });
    flip.on("flip", function(e){ zeigeStand(e.data); });
    flip.on("changeState", function(e){
      if (e.data === "read") zeigeStand(flip.getCurrentPageIndex());
    });

    registerBauen();

    
    
    var start = parseInt(new URLSearchParams(location.search).get("seite"), 10);
    if (!isNaN(start) && start >= 1 && start <= seiten.length) {
      ladeUm(start - 1);
      flip.turnToPage(start - 1);
      zeigeStand(start - 1);
    } else {
      zeigeStand(0);
    }
  }

  function mag(){
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  
  
  
  function seitenMass(){
    var rahmen = document.querySelector(".kat-rahmen");
    var stil = getComputedStyle(rahmen);
    var frei = rahmen.clientWidth
             - parseFloat(stil.paddingLeft) - parseFloat(stil.paddingRight);
    var pfeilZone = window.matchMedia("(max-width:900px)").matches ? 0 : 140;
    frei = Math.max(240, frei - pfeilZone);

    var mass = doppelseitig() ? frei / 2 : frei;
    
    
    return Math.round(Math.min(mass, 760, (window.innerHeight - 330)));
  }

  function doppelseitig(){
    return window.matchMedia("(min-width:760px)").matches;
  }

  
  
  
  function grenzeSetzen(){
    var s = seitenMass();
    var zone = document.querySelector(".kat-buchzone");
    if (zone) {
      zone.style.setProperty("--seite-breite", s + "px");
      zone.style.maxWidth = (doppelseitig() ? s * 2 : s) + "px";
    }
    return s;
  }

  
  
  
  
  
  
  function deckelStand(nr){
    var zone = document.querySelector(".kat-buchzone");
    if (!zone) return;
    zone.classList.toggle("einzeln",
      doppelseitig() && (nr === 1 || nr === manifest.seiten.length));
  }


  function seitenAlt(s){
    if (s.produkte && s.produkte.length)
      return materea_t("js.katalog.katalogseite",{n:s.nr}) + ": " + s.produkte.join(", ");
    if (s.kapitel) return materea_t("js.katalog.katalogseite",{n:s.nr}) + ": " + s.kapitel;
    return materea_t("js.katalog.katalogseite",{n:s.nr});
  }

  
  function ladeUm(index){
    var kinder = buchEl.querySelectorAll(".seite");
    for (var i = Math.max(0, index - LADEFENSTER);
         i < Math.min(kinder.length, index + LADEFENSTER + 2); i++) {
      lade(kinder[i]);
    }
  }

  function lade(el){
    if (!el) return;
    var img = el.querySelector("img");
    if (!img || img.src) return;
    img.onload = function(){ img.classList.add("da"); el.classList.remove("laedt"); };
    img.src = img.getAttribute("data-src");
  }

  
  function zeigeStand(index){
    ladeUm(index);
    var nr = index + 1;
    zahlEl.value = nr;
    deckelStand(nr);

    document.getElementById("zurueck").disabled = index <= 0;
    document.getElementById("vor").disabled = nr >= manifest.seiten.length;

    
    var sichtbar = [nr];
    var doppelt = flip && flip.getOrientation && flip.getOrientation() === "landscape";
    if (doppelt && nr > 1 && nr < manifest.seiten.length) {
      sichtbar = (nr % 2 === 0) ? [nr, nr + 1] : [nr - 1, nr];
      sichtbar = sichtbar.filter(function(n){
        return n >= 1 && n <= manifest.seiten.length;
      });
    }

    produkteZeigen(sichtbar);
    markiereRegister(nr);
  }

  function produkteZeigen(nummern){
    var namen = [], kapitel = null;
    nummern.forEach(function(n){
      var s = manifest.seiten[n - 1];
      if (!s) return;
      if (s.kapitel && !kapitel) kapitel = s.kapitel;
      s.produkte.forEach(function(p){
        if (namen.indexOf(p) === -1) namen.push(p);
      });
    });

    kopfEl.textContent = nummern.length > 1
      ? materea_t("js.katalog.seiten_zwei",{a:nummern[0],b:nummern[1]}) + (kapitel ? " · " + kapitel : "")
      : materea_t("js.katalog.seite",{a:nummern[0]}) + (kapitel ? " · " + kapitel : "");

    listeEl.innerHTML = "";
    if (!namen.length) {
      
      
      
      var leer = document.createElement("li");
      leer.className = "kat-produkte-leer";
      if (nummern[0] === 1 || nummern[nummern.length - 1] === manifest.seiten.length) {
        leer.textContent = materea_t("js.katalog.blaettern");
      } else if (kapitel) {
        leer.textContent = materea_t("js.katalog.kapitel_folgt",{kapitel:kapitel});
      } else {
        leer.textContent = materea_t("js.katalog.kein_produkt");
      }
      listeEl.appendChild(leer);
      return;
    }

    namen.forEach(function(name){
      var ziel = zuordnung[name] || {};
      var handle = ziel.handle;
      var li = document.createElement("li");
      if (handle) {
        var a = document.createElement("a");
        a.className = "kat-chip";
        
        
        
        a.href = STORE_PRODUKT + handle
               + (ziel.variante ? "?variant=" + ziel.variante : "");
        a.textContent = name;
        li.appendChild(a);
      } else {
        var s = document.createElement("span");
        s.className = "kat-chip ohne";
        s.textContent = name;
        s.title = materea_t("js.katalog.nicht_im_shop");
        li.appendChild(s);
      }
      listeEl.appendChild(li);
    });
  }

  
  function registerBauen(){
    manifest.kapitel.forEach(function(k){
      var b = document.createElement("button");
      b.type = "button";
      b.textContent = k.name;
      b.addEventListener("click", function(){ springe(k.nr); registerZu(); });
      kapitelEl.appendChild(b);
    });

    manifest.seiten.forEach(function(s){
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("data-nr", s.nr);
      b.innerHTML = '<img loading="lazy" src="' + s.thumb + '" alt="">'
                  + "<span>" + materea_t("js.katalog.seite_kurz",{n:s.nr}) + "</span>";
      b.addEventListener("click", function(){ springe(s.nr); registerZu(); });
      gitterEl.appendChild(b);
    });
  }

  function markiereRegister(nr){
    var alt = gitterEl.querySelector("button.hier");
    if (alt) alt.classList.remove("hier");
    var neu = gitterEl.querySelector('button[data-nr="' + nr + '"]');
    if (neu) neu.classList.add("hier");
  }

  function springe(nr){
    var i = Math.max(0, Math.min(manifest.seiten.length - 1, nr - 1));
    ladeUm(i);
    flip.turnToPage(i);
    zeigeStand(i);
  }

  function registerAuf(){
    registerEl.classList.add("auf");
    document.getElementById("registerauf").setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }
  function registerZu(){
    registerEl.classList.remove("auf");
    document.getElementById("registerauf").setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  
  document.getElementById("zurueck").addEventListener("click", function(){
    flip.flipPrev();
  });
  document.getElementById("vor").addEventListener("click", function(){
    flip.flipNext();
  });
  document.getElementById("registerauf").addEventListener("click", function(){
    registerEl.classList.contains("auf") ? registerZu() : registerAuf();
  });
  document.getElementById("registerzu").addEventListener("click", registerZu);
  registerEl.addEventListener("click", function(e){
    if (e.target === registerEl) registerZu();
  });

  zahlEl.addEventListener("change", function(){
    var n = parseInt(zahlEl.value, 10);
    if (!isNaN(n)) springe(n);
  });

  document.addEventListener("keydown", function(e){
    if (e.target.tagName === "INPUT") return;
    if (e.key === "ArrowLeft") flip.flipPrev();
    if (e.key === "ArrowRight") flip.flipNext();
    if (e.key === "Escape" && registerEl.classList.contains("auf")) registerZu();
  });

  var vollbildKnopf = document.getElementById("vollbild");
  var vollbildWort = document.getElementById("vollbildwort");
  vollbildKnopf.addEventListener("click", function(){
    if (!document.fullscreenElement) {
      (document.documentElement.requestFullscreen ||
       document.documentElement.webkitRequestFullscreen).call(document.documentElement);
    } else {
      (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    }
  });
  document.addEventListener("fullscreenchange", function(){
    vollbildWort.textContent = document.fullscreenElement ? materea_t("js.katalog.ansicht_schliessen") : materea_t("js.katalog.vollbild");
  });
})();
